import $ from 'jquery';
import _ from 'lodash';
import {
  toggleEditorHomeMenu,
  calculateFormat,
  calculateFormatDpi,
  resizeDimensions,
  getCanvasBaseZoom,
  composeMetadataCanvasNavText,
} from '~loader/loader-utils';
import { loadEditor } from '~core';
import { onCanvasNotFound } from '~src/errors';
import { fetchTemplateById } from '~src/templates';
import { modifyState } from '~src/state';

export const openTemplateManagerById = async (templateId) => {
  window.editorLoader.templateId = templateId;

  $('.app-spinner').show();

  toggleEditorHomeMenu();

  try {
    const template = await fetchTemplateById(templateId);
    composeMetadataCanvasNavText();
    const { formatWidth, formatHeight } = calculateFormat();

    if (template.isGlobal) {
      const sortedTemplatePages = _.sortBy(
        template.editor_templates_default_pages,
        ['order']
      );

      modifyState(
        'pages',
        sortedTemplatePages.map((page) => {
          if (page.animations) {
            if (typeof page.animations === 'string') {
              page.animations = JSON.parse(page.animations);
            }
          }
          return page;
        })
      );
    } else {
      const sortedTemplatePages = _.sortBy(template.editor_templates_pages, [
        'order',
      ]);

      modifyState(
        'pages',
        sortedTemplatePages.map((page) => {
          if (page.animations) {
            if (typeof page.animations === 'string') {
              page.animations = JSON.parse(page.animations);
            }
          }
          return page;
        })
      );
    }

    const dpi = calculateFormatDpi(template, window.editorLoader.sourceDPI);

    const { width, height } = resizeDimensions(
      formatWidth,
      formatHeight,
      window.editorLoader.defaultDPI,
      dpi
    );

    const zoomValue = getCanvasBaseZoom(width, height);

    $('.app-spinner').hide();

    await loadEditor({
      width,
      height,
      zoom: zoomValue,
    });
  } catch (error) {
    console.error(error);
    $('.app-spinner').hide();
    onCanvasNotFound();
  }
};
